import { useEffect, useEffectEvent } from "react";

export function useOnUnmount(callback: () => void) {
  // useEffectEvent creates a stable reference that always calls the latest callback
  const stableCallback = useEffectEvent(callback);

  useEffect(() => () => stableCallback(), []);
}
